module.exports = __webpack_public_path__ + "static/media/Meadow-Hill-bylaws.bd800133.pdf";